module.exports = __webpack_public_path__ + "static/media/avatar-D_J.15274602.png";